module.exports = __webpack_public_path__ + "static/after1-161539f075cd4c511969a345ddb363c6.png";